import styles from "./Evaluaciones.module.css";

export function Calificacion({ value }) {
  if (value === null) {
    return <span className={styles.muted}>Sin calificar</span>;
  }

  return (
    <span className={styles.score}>
      {value}
    </span>
  );
}
